var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"personal"},[_c('h1',[_vm._v("联系 Truyu Tseng")]),_c('p',[_vm._v("邮箱: "),_c('a',{attrs:{"href":"mailto:chuyu@zeng.ink"}},[_vm._v("chuyu@zeng.ink")])]),_c('p',[_vm._v("Matrix: "),_c('a',{attrs:{"href":"https://matrix.to/#/@0x7c26:envs.net"}},[_vm._v("@0x7c26:envs.net")])])])])
}]

export { render, staticRenderFns }